// extracted by mini-css-extract-plugin
module.exports = {"home-battery-F":"F_home-battery-F__q_TQp"};